import {computed, observable, override} from "mobx";
import {BaseModuleState} from "../../../infrastructure/models/base-module-state";
import {BaseMobxState} from "../../../infrastructure/mobx/base-mobx-state";
import {NavigationManager} from "../../../core/managers/navigation-manager";
import {AppStore} from "../../../core/app/app-store";
import {LoggerUtils} from "../../../infrastructure/utils/logger/logger-utils";
import {DatetimeUtils} from "../../../infrastructure/utils/datetime-utils";
import {DeviceViewModel} from "../../../core/models/device.view-model";
import {TermsUtils} from "../../../infrastructure/utils/terms-utils";
import {LanguageMenuModuleConfig} from "../language-menu-module.config";
import {LanguageViewModel} from "../../../domain/locale/models/language/language.view-model";
import {LANGUAGE_MENU} from "../language-menu-module.consts";
import {LanguageDomainModel} from "../../../domain/locale/models/language/language.domain-model";
import {makeObservableClass} from "../../../infrastructure/decorators/observable";
import {LanguageMenuModuleMenuModel} from "./context/language-menu-module.menu.model";
import {LanguageMenuModuleMenuSlimModel} from "./context/language-menu-module.menu.slim-model";
import {LanguageMenuModuleMenuClassicModel} from "./context/language-menu-module.menu.classic-model";
import {LanguageMenuModuleMenuExpandModel} from "./context/language-menu-module.menu.expand-model";

@makeObservableClass
export class LanguageMenuModuleState extends BaseModuleState {
  @observable _languages: Array<LanguageDomainModel>;
  @observable selectedLanguage: LanguageViewModel;
  @observable isMenuOpen: Boolean;
  type: String;

  static injectables = [...BaseMobxState.injectables, NavigationManager, AppStore, LoggerUtils, DatetimeUtils, DeviceViewModel, TermsUtils, LanguageMenuModuleConfig];

  @override get isPopulated(): Boolean {
    return this.languages;
  }

  @computed get menuModel(): LanguageMenuModuleMenuModel {
    let menuModel: LanguageMenuModuleMenuModel = null;

    switch (this.type) {
      case LANGUAGE_MENU.MENU_TYPE.slim:
        menuModel = LanguageMenuModuleMenuSlimModel;
        break;
      case LANGUAGE_MENU.MENU_TYPE.classic:
        menuModel = LanguageMenuModuleMenuClassicModel;
        break;
      case LANGUAGE_MENU.MENU_TYPE.expand:
        menuModel = LanguageMenuModuleMenuExpandModel;
        break;
      default:
        menuModel = LanguageMenuModuleMenuModel;
        break;
    }

    return new menuModel(this.type, this.selectedLanguage, this.languages, this.isMenuOpen, this.device.screenWidth);
  }

  @computed get languages(): Array<LanguageViewModel> {
    const languages: Array<LanguageViewModel> = this._languages?.filter(
      (lang: LanguageDomainModel) => !lang.invalidUserCountryIds?.includes(this.appState.locale.userCountryId))?.map(
        (language: LanguageDomainModel) => new LanguageViewModel(language, this.navigationManager))

    return languages
  }
}

